import ConversationPanel from "./ConversationPanel.tsx";
import CirclePanel from "../circle/CirclePanel.tsx";
import CircleContent from "../circle/CircleContent.tsx";
import ConversationDrawer from "./ConversationDrawer.tsx";
import { Box, Grid } from "@mui/material";
import { useTypedSelector } from "../../hooks.tsx";
import * as React from "react";
import { i18n } from "@lingui/core";
import { I18nProvider } from "@lingui/react";

function ConversationContainer() {
  const { isLoggedIn, anonymousSession } = useTypedSelector(
    (state) => state.authState,
  );

  const [openDrawer, setOpenDrawer] = React.useState(false);

  if (!(isLoggedIn || anonymousSession)) {
    return (
      <I18nProvider i18n={i18n}>
        <CirclePanel>
          <CircleContent />
        </CirclePanel>
      </I18nProvider>
    );
  }

  if (anonymousSession) {
    return (
      <I18nProvider i18n={i18n}>
        <Grid>
          <ConversationPanel openDrawer={false} />;
        </Grid>
      </I18nProvider>
    );
  } else {
    return (
      <I18nProvider i18n={i18n}>
        <Box width="100%">
          <ConversationDrawer
            openDrawer={openDrawer}
            setOpenDrawer={setOpenDrawer}
          />
          <ConversationPanel
            openDrawer={openDrawer}
            setOpenDrawer={setOpenDrawer}
          />
        </Box>
      </I18nProvider>
    );
  }
}

export default ConversationContainer;
